export default {
  pageTitle: {
    id: 'seller-invoices-your_wallet-page_title',
    defaultMessage: 'Your wallet',
  },
}
